import type { RagnarButtonState } from './types';

export const LOADING_STATE: RagnarButtonState = 'loading';
export const SUCCESS_STATE: RagnarButtonState = 'success';
export const ERROR_STATE: RagnarButtonState = 'error';
